import '../css/Resume.css'

import CVCard from '../components/CVCard'
import CVItem from '../components/CVitem'

import pdfIcon from '../images/pdfIcon.png'

import { CVData } from '../data/CVData'

const Resume = () => {
  return (
    <div className="content">
      <div className="title">
        <h1>CV</h1>
        <img className="pdfIcon" src={[pdfIcon]} alt="" />
      </div>

      <CVCard
        title="General Information"
        content={
          <>
            <hr />
            <div>
              <b>Full Name:</b>&nbsp;Qinren Zhou
            </div>
            <br />
            <div>
              <b>Languages:</b>&nbsp;English,&nbsp;Chinese
            </div>
            <br />
            <div>
              <b>Email:</b>&nbsp;qz142@georgetown.edu
            </div>
          </>
        }
      />

      {CVData.map((module) => {
        return (
          <CVCard
            title={module.title}
            content={module.data.map((item) => {
              return (
                <CVItem
                  time={item.time}
                  name={item.name}
                  desc={item.desc}
                  points={item.points}
                />
              )
            })}
          />
        )
      })}

      <CVCard
        title="Skills"
        content={
          <>
            <hr />
            <div className="technical">
              <b>Technical:</b>&nbsp;R (ggplot2, Shiny, dplyr), Python (Pandas,
              scikit learn, Matplotlib), SQL (MySQL, PostgreSQL, MongoDB),
              D3.js, Tableau, Linux, Bash, Git, Spark, Hadoop, AWS, Azure, ETL,
              API, HTML, SPSS, Stata, Microsoft Excel
            </div>
            <hr />
            <div className="professional">
              <b>Professional skills:</b>&nbsp;Bilingual Consulting, Data
              Management, Customer Analysis, Product Analysis, Data
              Visualization, Natural Language Processing
            </div>
          </>
        }
      />
    </div>
  )
}

export default Resume
